import { render, staticRenderFns } from "./goodsProperty.vue?vue&type=template&id=0a16a704&scoped=true"
import script from "./goodsProperty.vue?vue&type=script&lang=js"
export * from "./goodsProperty.vue?vue&type=script&lang=js"
import style0 from "./goodsProperty.vue?vue&type=style&index=0&id=0a16a704&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a16a704",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a16a704')) {
      api.createRecord('0a16a704', component.options)
    } else {
      api.reload('0a16a704', component.options)
    }
    module.hot.accept("./goodsProperty.vue?vue&type=template&id=0a16a704&scoped=true", function () {
      api.rerender('0a16a704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/goodsProperty.vue"
export default component.exports